function About() {

  return (
    <section className="about">

      <h1>About Us</h1>

      <p>
        We are a premium car dealership platform
        offering the finest vehicles from around
        the world.

        Our mission is to redefine the car buying
        experience using technology, performance,
        and innovation.
      </p>

      <div className="about-stats">

        <div>
          <h2>500+</h2>
          <p>Cars Sold</p>
        </div>

        <div>
          <h2>300+</h2>
          <p>Happy Clients</p>
        </div>

        <div>
          <h2>50+</h2>
          <p>Brands</p>
        </div>

      </div>

    </section>
  );
}

export default About;